import _     from 'underscore';
import React from 'react';

import { CORVAL_PRODUCT_NAME } from '../constants/SystemEnums';
import { STRING_CONVERSION }   from '../constants/FormatStringEnums';

interface UsePageMetaHooks {
	
	updatePageTitle: ( title: string, prefix: string ) => void,
}

export const updatePageTitle: UsePageMetaHooks['updatePageTitle'] = ( title, prefix = null ) => {
	
	document.title = _.compact( [ CORVAL_PRODUCT_NAME, prefix, title ] ).join( ` ${ STRING_CONVERSION.DELIMITER } ` );
}

function usePageMeta(): UsePageMetaHooks{
	
	return {
		updatePageTitle
	}
}

export { usePageMeta };
